import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { getAttendanceApi, saveAttendanceApi } from '../APIURL';
import axios from 'axios';
const Attendancemaster = () => {
    const [Roll, setRoll]=useState(0)

    const saveFun = (e) => {
        e.preventDefault()
        axios.post(saveAttendanceApi + Roll)
          .then((res) => {
            if (res.data === "SAVED") {
              alert("Your attendance has been recorded")
            }
            else if (res.data === "EXIST") {
              alert("Your attendance has already recorded")
            }
          })
          .catch((err) => {
            alert("Failed to record your attendance, try again")
            console.log(err)
          })
      }


  return (
    <div className='container'>
    <div className="row">
        <div className="col-md-4 offset-md-4">
        <Form style={{marginTop:"150px"}} onSubmit={saveFun}>
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label>Enter Roll No</Form.Label>
        <Form.Control type="number" placeholder="Enter Roll No" onChange={(e)=>setRoll(e.target.value)} value={Roll} required />
 
      </Form.Group>
      <Button variant="primary" type="submit">
        Submit
      </Button>
    </Form>

        </div>
    </div>


</div>
  );
}

export default Attendancemaster